<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-back-button default-href="/"></ion-back-button>
        </ion-buttons>
        <ion-title>Locate Your Facility</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content padding>
        <div style="height: 400px; width: 100%">
            <l-map ref="mymap" style="height: 400px;" :zoom="zoom" :center="center">
                <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
                <l-marker v-for="marker in markers" :key="marker.id" :lat-lng="marker.latlng"
                :icon="marker.special_icon?hospitalIcon:null">
                  <l-popup>Name: {{marker.name}}<br/>
                    Mun: {{marker.district}}, {{marker.local}}<br/>
                    Type: {{marker.type}}
                  </l-popup>
                </l-marker>
                <l-polyline v-for="p in polylines" :key="p.id" :lat-lngs="p.latlngs" :color="p.color"></l-polyline>
            </l-map>
        </div>
        <div>
          <form>
            <div id="mylist">
              <vue-google-autocomplete
                  ref="address"
                  id="map"
                  classname="form-control"
                  placeholder="Please type your location"
                  v-on:placechanged="getAddressData"
                  country="za"
              >
              </vue-google-autocomplete>
            </div>
            <br/>
            <ion-item>
                <ion-label>Type</ion-label>
                <ion-select value="All" placeholder="Select One">
                    <ion-select-option>All</ion-select-option>
                    <ion-select-option>Clinic</ion-select-option>
                    <ion-select-option>Hospital</ion-select-option>
                </ion-select>
            </ion-item>
            <br/>
            
            <ion-button expand="full">Find Facility</ion-button>
        </form>
        </div>
    </ion-content>
  </ion-page>
</template>

<script>
import VueGoogleAutocomplete from 'vue-google-autocomplete';
import 'bootstrap/dist/css/bootstrap.min.css';
import {LMap,LTileLayer,LMarker,LPopup,LPolyline} from 'vue2-leaflet';

import L from 'leaflet';
export default {
    name:'facility',
    components:{
        LMap,
        LTileLayer,
        LPopup,
        LMarker,
        LPolyline,
        VueGoogleAutocomplete
    },
    data(){
        return {
            selected_address:null,
            result_data:null,
            result_id:null,
            all_hospitals:[],
            current_location:null,
            polylines:null,
            markers:[],
            hospitalIcon:L.icon({
                iconUrl:require('../assets/hospital_icon.png'),
                iconSize:[50,50],
                iconAnchor:[25,50]
            }),
            zoom:14,
            center: L.latLng(-29.520628, 31.043783),
            url:'http://{s}.tile.osm.org/{z}/{x}/{y}.png',
            attribution:'&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        }
    },
    methods:{
        loadMap(){
            setTimeout(() => {
                this.$refs.mymap.mapObject.invalidateSize(); 
            }, 100);
        },
        loadHospitals(){
            const base_url=this.$store.get('base_url');
            this.$http.get(base_url+'/api/hospitals')
            .then((res)=>this.all_hospitals=res.data)
            .catch((err)=>console.log(err));
        },
        getAddressData: function (addressData, placeResultData, id) {
            this.selected_address = addressData;
            this.result_data=placeResultData;
            this.result_id=id;
            //set marker data

            this.current_location=L.latLng(addressData.latitude, addressData.longitude);
            this.center=L.latLng(addressData.latitude, addressData.longitude);
            
            this.findNearest(5);
        },
        findNearest(maxResults){
            //compute distance
            for(var i=0;i<this.all_hospitals.length;i++){
                if(this.all_hospitals[i].latitude&&this.all_hospitals[i].longitude){
                    this.all_hospitals[i].latlng=L.latLng(parseFloat(this.all_hospitals[i].latitude.replace(',', '.')),parseFloat(this.all_hospitals[i].longitude.replace(',', '.')));
                    this.all_hospitals[i].distance=this.current_location.distanceTo(this.all_hospitals[i].latlng)/1000.0;
                }else{//no location data
                    this.all_hospitals[i].latlng=null;
                    this.all_hospitals[i].distance=1000000;
                }
            }
            //sort
            this.all_hospitals.sort(function(a,b){
                return a.distance-b.distance;
            });
            //create polylines
            this.polylines=[];
            let temp_p=[];
            for(var j=0;j<maxResults;j++){
                temp_p.push({
                    latlngs:[this.current_location,this.all_hospitals[j].latlng],
                    color:'orange',
                    id:'poly-'+this.all_hospitals[j].id
                });
            }
            this.polylines=temp_p;
            //add markers
            this.markers=[];
            this.markers.push({
                name:'Your Location',
                latlng:this.current_location
            });
            for(var k=0;k<maxResults;k++){
                let mk=this.all_hospitals[k];

                mk.special_icon=true;
                this.markers.push(mk);
            }
        }
    },
    mounted(){
        this.loadMap();
    },
    created(){
        this.loadHospitals();
    }
}
</script>

<style scoped>
ion-toolbar {
  --ion-toolbar-background:#fbc414;
  --ion-text-color:white;
}
ion-back-button{
    --color:white;
}
ion-button{
    --background:#1b9346;
}
#rounded{
    --border-color: #d2d2d2;
  --border-radius: 10px;
  --border-width: 1px;
  --box-shadow: 2px gray;
  --highlight-height: 0;
  --background: #f8f9fa;
  margin: 10px;
}
#mylist{
  padding-top: 10px;
  padding-left: 10px;
  padding-right: 10px;
}
</style>